





























// @ts-ignore
import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps'
import { debounce } from 'throttle-debounce'
import { PropType } from '@nuxtjs/composition-api'
import { AdaptedOffice } from '@/apollo/adapters/modules/officeAdapter'

const MARKER_DEFAULT = require('@/assets/svg/mapMarker.svg')
const MARKER_HOVER = require('@/assets/svg/mapMarkerHover.svg')
const MARKER_ACTIVE = require('@/assets/svg/mapMarkerActive.svg')
const CLUSTER_ICON = require('@/assets/svg/cluster.svg')
const HOVER_CLUSTER_ICON = require('@/assets/svg/hoverCluster.svg')
const PANORAMIC_VIEW = 10
const DETAILED_VIEW = 14

export default {
  name: 'FarmsMap',
  components: {
    yandexMap,
    ymapMarker,
  },
  props: {
    offices: {
      type: Array,
      default: () => [],
    } as PropType<AdaptedOffice[]>,
    selectedOffice: {
      type: Object,
      default: null,
    } as PropType<AdaptedOffice | null>,
    icon: {
      type: Object,
      required: false,
      default: () => ({
        layout: 'default#image', // 'default#imageWithContent' для использования с контентом
        imageHref: MARKER_DEFAULT, // адрес изображения или data:image/svg+xml;base64
        imageSize: [26, 26], // размер иконки в px
        imageOffset: [-13, -13], // смещение иконки в px,
        content: 'TEST',
        contentOffset: [-22, -55],
        // contentLayout:
        //   '<div style="background: #FFFFFF; border-radius: 10px; color: #000; font-weight: bold;">$[properties.iconContent]</div>' // строковый HTML шаблон для контента
      }),
    },
    centerMapInit: {
      type: Array,
      default: () => [],
    },
    address: {
      type: String,
      default: '',
    },
    zoomAddress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      markerIcon: {
        layout: 'default#imageWithContent',
        imageHref: MARKER_DEFAULT,
        imageSize: [24, 31],
        imageOffset: [-12, -27],
        contentOffset: [0, 15],
      },
      activeMarkerIcon: {
        layout: 'default#imageWithContent',
        imageHref: MARKER_ACTIVE,
        imageSize: [24, 31],
        imageOffset: [-12, -27],
        contentOffset: [0, 15],
      },
      settings: {
        apiKey: '77943fb1-3c5f-4a17-a76f-c98167739193',
        lang: 'ru_RU',
        coordorder: 'latlong',
        version: '2.1',
      }, // настройки плагина
      options: {
        suppressMapOpenBlock: true,
      },
      controls: [],
      isInited: false,
      myMap: null,
      currentRoute: null,
      centerMap: null,
      clusterCallbacks: {
        1: {
          mouseenter: this.changeIconCluster,
          mouseleave: this.changeIconCluster,
          click: this.changeIconCluster,
        },
      },
      clusterOptions: {
        1: {
          clusterOpenBalloonOnClick: false,
          clusterNumbers: [10, 100, 1000],

          clusterIcons: this.getClusterIcons(CLUSTER_ICON),
        },
      },
    }
  },
  watch: {
    centerMapInit() {
      this.centerMap = this.centerMapInit
    },
  },
  async mounted() {
    await loadYmap(this.settings).then(() => {
      this.isInited = true
      this.$store.commit('settings/SET_INIT_MAP', true)
    })
  },

  created() {
    if (process.browser) {
      this.addListeners()
    }

    this.onActionend = () => {
      const bounds = this.myMap.getBounds()
      const boundsParam = {
        left: bounds[0][0],
        top: bounds[0][1],
        right: bounds[1][0],
        bottom: bounds[1][1],
      }
      this.$emit('bounds-change', boundsParam)
    }

    this.debouncedBounceChange = debounce(1000, false, this.onActionend)
  },

  beforeDestroy() {
    if (process.browser) {
      this.removeListeners()
      this.$store.commit('settings/SET_INIT_MAP', false)
    }
  },

  methods: {
    moveToCenterCart() {
      this.moveToPosition(this.centerMap, PANORAMIC_VIEW)
    },

    moveToOffice(office: AdaptedOffice) {
      this.centerMap = office.coords
      this.moveToPosition(office.coords, DETAILED_VIEW)
    },

    zooming() {
      const singleAction = new ymaps.map.action.Single({
        zoom: 10,
        duration: 500,
        timingFunction: 'ease-in',
      })
      this.myMap.action.execute(singleAction)
    },
    getClusterIcons(icon) {
      return [
        {
          href: icon,
          size: [40, 40],
          offset: [-20, -20],
          shape: {
            type: 'Circle',
            coordinates: [0, 0],
            radius: 20,
          },
        },
        {
          href: icon,
          size: [44, 44],
          offset: [-22, -22],
          shape: {
            type: 'Circle',
            coordinates: [0, 0],
            radius: 22,
          },
        },
        {
          href: icon,
          size: [48, 48],
          offset: [-24, -24],
          shape: {
            type: 'Circle',
            coordinates: [0, 0],
            radius: 24,
          },
        },
        {
          href: icon,
          size: [56, 56],
          offset: [-28, -28],
          shape: {
            type: 'Circle',
            coordinates: [0, 0],
            radius: 28,
          },
        },
      ]
    },

    changeIconCluster(evt) {
      const target = evt.get('target')
      const type = evt.get('type')
      if ('getGeoObjects' in target) {
        if (type === 'mouseenter') {
          target.options.set(
            'clusterIcons',
            this.getClusterIcons(HOVER_CLUSTER_ICON)
          )
        } else if (type === 'mouseleave') {
          target.options.set('clusterIcons', this.getClusterIcons(CLUSTER_ICON))
        } else if (type === 'click') {
          const obj = target.getGeoObjects().reduce(
            (akk, marker) => {
              const [lat, lon] = marker.geometry._coordinates
              return {
                lat: new Set([...akk.lat, lat]),
                lon: new Set([...akk.lon, lon]),
              }
            },
            { lat: new Set([]), lon: new Set([]) }
          )
          if (
            Array.from(obj.lat).length === 1 &&
            Array.from(obj.lon).length === 1
          ) {
            this.$emit('show-button')
          }
        }
      }
    },
    changeIcon(evt) {
      const target = evt.get('target')
      const type = evt.get('type')
      if (type === 'mouseenter') {
        if (target.options.get('iconImageHref') !== MARKER_ACTIVE)
          target.options.set('iconImageHref', MARKER_HOVER)
      } else if (type === 'mouseleave') {
        if (target.options.get('iconImageHref') !== MARKER_ACTIVE)
          target.options.set('iconImageHref', MARKER_DEFAULT)
      }
    },
    onInitialized(instance) {
      this.myMap = instance
      this.myMap.events.add('actionend', this.debouncedBounceChange)
      this.debouncedBounceChange()
    },
    async moveCenterToAddress(address, zoom) {
      if (!address) {
        return
      }
      const geocoder = await ymaps.geocode(address)
      const coord = geocoder.geoObjects.get(0).geometry.getCoordinates()
      this.centerMap = coord
      this.moveToPosition(coord, zoom)
    },
    moveToPosition(coord = null, zoom = 10) {
      if (!coord) {
        return
      }
      const singleAction = new ymaps.map.action.Single({
        center: coord,
        zoom,
        duration: 500,
        timingFunction: 'ease-in',
      })
      this.myMap.action.execute(singleAction)
    },
    addListeners() {
      document.addEventListener('click', this.openFarmFromCluster)
    },
    removeListeners() {
      document.removeEventListener('click', this.openFarmFromCluster)
    },
    openFarmFromCluster(evt) {
      if (
        evt.target.classList &&
        evt.target.classList.contains('cluster-btn')
      ) {
        this.$emit(
          'open-office',
          this.offices.find((_) => String(_.id) === evt.target.dataset.id)
        )
      }
    },

    getMarkerIcon({ id }) {
      return this.selectedOffice?.id === id
        ? this.activeMarkerIcon
        : this.markerIcon
    },
  },
}
